// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"264":"3705c59d","872":"30285b49"}[chunkId] + ".chunk.css";
};